export class StoresConstant {
    static readonly NAME_SEARCH = 'namesearch';
    static readonly SLASH_RETAILSTORE = '/retailer-store';
    static readonly SLASH_STORE = '/store';
    static readonly SLASH_USERS = '/users';
    static readonly STORES = '/stores';
    static readonly SLASH = '/';
    static readonly SLASH_RETAILER = '/retailers';
    static readonly SLASH_STORE_SEARCH = '/stores?';
    static readonly EQUALS = '=';
    static readonly ASCENDING_ORDER = '=asc';
    static readonly DESCENDING_ORDER = '=desc';
    static readonly STORE_CODE = 'storeCode';
    static readonly STORE_NAME = 'storeName';
    static readonly CUSTSTORE_ID = 'custStoreId';
    static readonly STORE_NUMBER = 'storenumber';
    static readonly COUNTRY = 'country';
    static readonly REGION = 'region';
    static readonly ADDRESS = 'address';
    static readonly POSTAL_CODE = 'postalcode';
    static readonly LOAD_FLAG = 'Y';
    static readonly UNLOAD_FLAG = 'N';
    static readonly EMPTY_VALUE = '';
    static readonly NAME_VALUE = $localize`:@@stores.dropdown.stores-name-text:Name`;
    static readonly COUNTRY_VALUE = $localize`:@@stores.stores-country-region-value:Location`;
    static readonly STORE_NAME_SEARCH = 'storenamesearch';
    static readonly RETAILER_NAME_SEARCH = 'retailernamesearch';
    static readonly COUNTRY_SEARCH = 'countrysearch';
    static readonly CUSTOM_STORE_SEARCH = 'customstoreidsearch';
    static readonly CUSTOM_STORE_VALUE = 'Custom Store ID';
    static readonly CREATED_TIME = 'createdtime';
    static readonly DOTS = '...';
    static readonly UPLOADSTORES = '/uploadstores';
    static readonly ASSIGNED_STORE_VALUE = $localize`:@@stores.dropdown.assigned-store-text:Assigned Store`;
    static readonly ASSIGNED_RETAILER_VALUE = $localize`:@@stores.dropdown.assigned-hq-text:Assigned HQ`;
    static readonly ROLE_VALUE = $localize`:@@active-users.role:Role`;
    static readonly RETAILER_NAME_CHECK = '?retailername=';
    static readonly DOWNLOAD = 'download';
    static readonly SEARCH_QUERY = '?';
    static readonly PAGE_NUMBER = '&pagenumber';
    static readonly SELECTED_LANGUAGE = '&locale=';
    static readonly SELECTED_LANGUAGE_ADMIN = '?locale=';
    static readonly RETAILER_NAME_SORT = 'retailername';

    // Sort order Key Values
    static readonly STORECODE_SORT = 'storeIdSort';
    static readonly STORENAME_SORT = 'storename';
    static readonly CUSTSTOREID_SORT = 'customstoreid';
    static readonly STORENUMBER_SORT = 'storenumber';
    static readonly COUNTRY_SORT = 'country';
    static readonly REGION_SORT = 'stateregionprovince';
    static readonly ADDRESS_SORT = 'address';
    static readonly POSTALCODE_SORT = 'postalcode';

    // invite store user
    static readonly USERMANAGMENT = '/usermanagment';
    static readonly INVITE = '/invite';
    static readonly USERMGMT = '/user-mgmt';
    static readonly PUBUSER = '/pubuser';
    static readonly SEARCH_URL = '?searchby=';
    static readonly SORTBY = '?sortby=';
    static readonly SORT_TYPE = '&sorttype';
}

export enum Enumvalues {
    VALUE_1 = '1',
    VALUE_2 = '2',
    VALUE_3 = '3',
    VALUE_4 = '4'
}
